import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
import './AlertBox.scss';

// interface for Alert Box
interface AlertBoxProps {
  open: boolean;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  confirmButtonText?: string;
  cancelButtonText?: string;
  primaryButton?: boolean;
  importantAlert?: boolean;
  onClose(response: 'confirm' | 'cancel'): void;
  loader?: boolean;
}

const AlertBox = (props: AlertBoxProps): React.ReactElement => {
  const {t} = useTranslation();

  // props de-structure
  const {
    open,
    onClose,
    title,
    description,
    primaryButton,
    importantAlert,
    confirmButtonText
  } = props;

  const [buttonsDisable, setButtonsDisable] = React.useState<boolean>(false);

  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );

  return (
    <Dialog
      BackdropProps={{
        invisible: true
      }}
      maxWidth={'md'}
      open={open}
      onClose={(_event, reason): void => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
      className={'alert-box-dialog-container'}
      PaperProps={{
        className: importantAlert ? 'important-alert-style' : ''
      }}
      aria-labelledby="alert-box-dialog"
      aria-describedby="alert-box-dialog">
      <DialogTitle disableTypography>{title}</DialogTitle>
      {description && <DialogContent>{description}</DialogContent>}
      <DialogActions>
        <Button
          variant={primaryButton ? 'contained' : 'text'}
          disabled={buttonsDisable}
          onClick={() => {
            setButtonsDisable(true);
            handleClose('confirm');
          }}
          color="primary">
          {buttonsDisable ? (
            <ButtonLoader />
          ) : (
            confirmButtonText || t('COMMON.RELOAD')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertBox;
